import { match } from "react-router";
import { MetricsType } from "../../../context/reports/utilities/types";

/**
 * Retrieve metrics type from URL parameter.
 */
export function getMetricsTypeFromUrl(match: match<{ type: string }>) {
  const requestedType = match.params.type
    ? match.params.type.toLowerCase()
    : undefined;
  const metricsType =
    requestedType === MetricsType.Gas.toLowerCase()
      ? MetricsType.Gas
      : requestedType === MetricsType.Water.toLowerCase()
      ? MetricsType.Water
      : MetricsType.Electricity;

  return metricsType;
}
